module.exports = __webpack_public_path__ + "img/dreams-pencil.d98fe86.png";